import { STYLES } from "../../config/styles";

interface DaysOpenCellProps {
  initiationDate: string | undefined;
  fallback?: string;
}

// Helper function to calculate days between dates
function calculateDaysOpen(initiationDate: string): number {
  if (!initiationDate) return 0;

  const startDate = new Date(initiationDate);
  const currentDate = new Date();
  // Reset time to midnight for accurate day calculation
  startDate.setHours(0, 0, 0, 0);
  currentDate.setHours(0, 0, 0, 0);
  const diffTime = currentDate.getTime() - startDate.getTime();
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

  return Math.max(0, diffDays); // Ensure non-negative
}

// Helper function to get display text
function getDisplayText(days: number): string {
  if (days === 0) return '<1 day';
  if (days === 1) return '1 day';
  return `${days} days`;
}

// Helper function to get background color class for badge
function getBadgeClass(days: number): string {
  if (days <= 2) return "bg-[var(--color-success)]"; // Green #23833F
  if (days <= 4) return "bg-[var(--color-warning)]"; // Yellow
  return "bg-[var(--color-destructive)]"; // Red
}

export function DaysOpenCell({ initiationDate, fallback = "—" }: DaysOpenCellProps) {
  if (!initiationDate || initiationDate === "N/A") {
    return (
      <td className={STYLES.table.cellPadding}>
        <span className="text-muted-foreground">{fallback}</span>
      </td>
    );
  }

  const daysOpen = calculateDaysOpen(initiationDate);
  const badgeClass = getBadgeClass(daysOpen);

  return (
    <td className={STYLES.table.cellPadding}>
      <span className={`inline-flex items-center px-2 py-1 rounded-tag ${badgeClass} text-white content-center justify-center`}>
        {getDisplayText(daysOpen)}
      </span>
    </td>
  );
}
